// Post-call email panel logic (SPEC §19, 2026-10-02). Pure; the panel (EmailPanel.tsx) renders what these say.
import type { SalesEmailContext, SalesEmailDraft } from '../../../src/shared/api-sales-email';

const EMAIL = /^[^\s@<>,;"]+@[^\s@<>,;"]+\.[^\s@<>,;"]+$/;

export interface SendForm { to: string; subject: string; body: string; consentOnCall: boolean; ownerOverride: boolean }

/** Why the Send button is off, in one sentence (null = it may be pressed). The server checks every rule again. */
export function sendBlockReason(ctx: SalesEmailContext | null, draft: SalesEmailDraft | null, f: SendForm, now = Date.now()): string | null {
  if (!ctx) return 'Loading…';
  if (ctx.sendBlocked) return ctx.sendBlocked;
  if (!draft) return 'Draft the email first.';
  if (!EMAIL.test(f.to.trim())) return 'Enter the email address.';
  if (!f.subject.trim()) return 'The subject is empty.';
  if (!f.body.trim()) return 'The email is empty.';
  if (ctx.canadaNeedsConsent && !f.consentOnCall) return 'Canada (CASL): tick that they gave you this address on this call.';
  if (ctx.nextAllowedAt && Date.parse(ctx.nextAllowedAt) > now && !(ctx.ownerCanOverride && f.ownerOverride)) {
    return ctx.ownerCanOverride ? 'This business was emailed in the last 7 days: tick "Send anyway (owner)" to override.'
      : 'This business was emailed in the last 7 days (one email per business a week; only the owner can override).';
  }
  return null;
}

/** "Thu, Oct 8, 2:15 PM" in the business's zone. */
export function followUpLabel(iso: string, tz: string): string {
  try {
    return new Date(iso).toLocaleString('en-US', { timeZone: tz, weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  } catch { return iso; }
}
